function Contact() {
  return (
    <section className="contact" id="contact">
      <div className="title reveal">
        <h2 className="section-title">Contact Me</h2>
      </div>
      <div className="content">
        <div className="row">
          <div className="card reveal">
            <div className="contact-icon">
              <i className="fas fa-map-marker-alt"></i>
            </div>
            <div className="info">
              <h3>Address</h3>
              <span>Bordeaux, France</span>
            </div>
          </div>
          <div className="card reveal">
            <div className="contact-icon">
              <i className="fas fa-phone"></i>
            </div>
            <div className="info">
              <h3>Phone</h3>
              <span>+33 6 22 32 38 72</span>
            </div>
          </div>
          <div className="card reveal">
            <div className="contact-icon">
              <i className="fas fa-envelope"></i>
            </div>
            <div className="info">
              <h3>Email Address</h3>
              <span>m.grauleau@gmail.com</span>
            </div>
          </div>
          <div className="card reveal">
            <div className="contact-icon">
              <i className="fas fa-globe"></i>
            </div>
            <div className="info">
              <h3>Website</h3>
              <span>grauleau-matthieu-portfolio.netlify.app</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
